// extracted by mini-css-extract-plugin
module.exports = {"DataPanel":"DataPanel_DataPanel__14OdH","header":"DataPanel_header__1w4dL","scrollContainer":"DataPanel_scrollContainer__3LonZ"};